export default "__VITE_ASSET__CrQAtti8__"